import React, { useContext, useEffect, useState } from "react";
import { TwoRow } from "../../core/layouts";

import DashboardTopContainer from "../DashboardTopContainer";
import OperationAudit from "./Operation Audit/OperationAuditContainer";
import TotalCompleteAudits from "./Total Audits vs Complete Audits/TotalCompleteAuditsContainer";
import GradingGraph from "./Grading Graph/GradingGraphContainer";
import DashboardGraphLayout from "../../layouts/DashboardGraphLayout/DashboardGraphLayout";
import RadarGraph from "./Radar Graph/RadarGraphContainer";
import useResponsive from "../../core/hooks/useResponsive";
import Level2 from "./GraphContainer/Level2/Level2";
import Level3 from "./GraphContainer/Level3/Level3";
import Level4 from "./GraphContainer/Level4/Level4";
import Level5 from "./GraphContainer/Level5/Level5";
import variables from "../../themes/base/styles/variables";
import { DashboardContext } from "../../globalContext/dashboard/dashboardProvider";
import { auditCreationYear } from "../../constants";
import { AuthContext } from "../../globalContext/auth/authProvider";

export const DashboardContainerStyles = {
  bottomSection: {
    height: variables.dasboardContainerHeight,
    display: variables.dBlock,
    marginTop: variables.dashboardContainerMarginTop,
    padding: variables.dashboardContainerBottomTopSectionPadding,
  },
  topSectionStyle: {
    backgroundColor: variables.bodyBg,
    padding: variables.dashboardContainerBottomTopSectionPadding,
    position: variables.position,
    width: variables.fullWidth,
    zIndex: variables.zIndex,
  },
  bottomSectionMobileStyle: (responsive) => {
    let marginTop;
    let height;

    if (responsive.isSm) {
      marginTop = variables.dashboardContainerMarginTop;
      height = variables.dasboardContainerHeight;
    } else if (responsive.isXs) {
      marginTop = variables.dashboardContainerMobileMarginTopMb;
      height = variables.dasboardContainerHeightMb;
    } else {
      marginTop = variables.dashboardContainerMobileMarginTop;
      height = variables.dasboardContainerHeight;
    }

    return {
      marginTop: marginTop,
      height: height,
    };
  },
  mobileTwoRow: {
    overflow: variables.unset,
  },
};

const DashboardContainer = () => {
  const responsive = useResponsive();
  const [dashboardState] = useContext(DashboardContext);
  const [filter, setFilter] = useState({
    productCategories: "",
    subCategories: "",
    countries: "",
    auditType: dashboardState?.query?.auditType || "",
    year: auditCreationYear[0].value.split("-")[0],
    DNSD: "",
  });

  const [authState] = useContext(AuthContext);
  useEffect(() => {
    setFilter({
      productCategories: "",
      subCategories: "",
      countries: "",
      auditType: "",
      year: auditCreationYear[0].value.split("-")[0],
      DNSD: "",
    });
  }, [authState?.currentRole?.id]);

  return (
    <TwoRow
      style={responsive.isMd ? {} : DashboardContainerStyles.mobileTwoRow}
      topSectionStyle={DashboardContainerStyles.topSectionStyle}
      topSection={
        <DashboardTopContainer filter={filter} setFilter={setFilter} />
      }
      bottomSectionStyle={{
        ...DashboardContainerStyles.bottomSection,
        ...(!responsive.isSm &&
          DashboardContainerStyles.bottomSectionMobileStyle(responsive)),
      }}
      bottomSection={
        <DashboardGraphLayout
          operationAuditGraph={<OperationAudit filter={filter} />}
          totalCompleteAuditsGraph={<TotalCompleteAudits filter={filter} />}
          gradingGraph={<GradingGraph filter={filter} />}
          radarGraph={<RadarGraph filter={filter} />}
          level2Graph={<Level2 filter={filter} />}
          level3Graph={<Level3 filter={filter} />}
          level4Graph={<Level4 filter={filter} />}
          level5Graph={<Level5 filter={filter} />}
        />
      }
    />
  );
};

export default DashboardContainer;
